import { AnalyticsBrowser } from '@segment/analytics-next';
import { logError } from '@/core/logger/log-wrapper';

export const analytics = AnalyticsBrowser.load({
  writeKey: process.env.SEGMENT_WRITE_KEY,
});

export function trackEvent(eventName, properties = {}) {
  try {
    analytics.track(eventName, {
      ...properties,
      name: eventName,
      source: 'web-hr',
    });
  } catch (e) {
    logError('Failed to track event', { eventName, properties }, e);
  }
}
